/** Расчёт плана турнира — та же формула, что на сервере
 *  (services/tournament_logic.americano_plan), для подсказки при создании. */

function gcd(a: number, b: number): number {
  return b ? gcd(b, a % b) : a
}

export interface PlanHint {
  rounds: number
  courts: number
  perPlayer: number
  resting: number
}

export function americanoPlan(n: number, rounds?: number | null, courts?: number | null): PlanHint | null {
  if (n < 4) return null
  let c = Math.floor(n / 4)
  if (courts) c = Math.max(1, Math.min(c, courts))
  const playing = 4 * c
  const step = n / gcd(n, playing)
  const target = rounds || n - 1
  let total = Math.max(step, Math.ceil(target / step) * step)
  if (total > 64) total = Math.floor(64 / step) * step
  return { rounds: total, courts: c, perPlayer: (total * playing) / n, resting: n - playing }
}

export function pairsPlan(n: number, courts?: number | null): PlanHint | null {
  if (n < 4 || n % 2) return null
  const teams = n / 2
  const tours = teams % 2 ? teams : teams - 1
  const games = Math.floor(teams / 2)
  const c = Math.max(1, Math.min(courts || games, games))
  return { rounds: tours * Math.ceil(games / c), courts: c, perPlayer: teams - 1, resting: 2 * (teams % 2) }
}

/** Mexicano: раунды по одному; авто — 6 (с отдыхом — до ближайшего «поровну»),
 *  rounds = −1 — без лимита (rounds в ответе 0). */
export function mexicanoPlan(n: number, rounds?: number | null, courts?: number | null): PlanHint | null {
  const base = americanoPlan(n, null, courts)
  if (!base) return null
  if (rounds === -1) return { ...base, rounds: 0, perPlayer: 0 }
  const p = americanoPlan(n, rounds || 6, courts)!
  return { ...base, rounds: p.rounds, perPlayer: p.perPlayer }
}

/** «Король корта»: пар — n/2, кортов — пар пополам, при нечётном числе пар
 *  одна отдыхает. Раунды по одному; rounds = −1 или 0 — без лимита (0 в ответе). */
export function kingPlan(n: number, rounds?: number | null): PlanHint | null {
  if (n < 4 || n % 2) return null
  const teams = n / 2
  const total = rounds && rounds > 0 ? rounds : 0
  return { rounds: total, courts: Math.floor(teams / 2), perPlayer: teams % 2 ? 0 : total, resting: 2 * (teams % 2) }
}
